import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	content: {
		defaultMessage: 'Collaborate on product requirements, documentation, plans, and so much more.',
		id: 'navigation-apps-shortcuts-sidebar.pages-menu-item.end-user-activate-nudge-provider.nudge.content',
		description:
			'A nudge tooltip on the Project Pages Jira to Confluence integration, to encourage admins to try out the newly activated product',
	},
	primaryActionText: {
		defaultMessage: 'OK',
		id: 'navigation-apps-shortcuts-sidebar.pages-menu-item.end-user-activate-nudge-provider.nudge.primary-action-text',
		description: 'Acknowledge button on the nudge tooltip on Project Pages',
	},
});
